import { combineReducers } from 'redux'
import APIRequest from '../helpers/APIRequest'
import _ from 'lodash';

export const RECEIVE_PROJECTS = 'RECEIVE_PROJECTS'
export const RECEIVE_PROJECT = 'RECEIVE_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'

const byId = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_PROJECTS:
      return {
        ...state,
        ...action.projects.reduce((obj, project) => {
          obj[project._id] = project
          return obj
        }, {})
      }
    case RECEIVE_PROJECT:
      return {
        ...state,
        [action.project._id]: action.project
      }
    case DELETE_PROJECT:
      const clone = _.clone(state);
      delete clone[action.projectId];
      return clone;
    default:
      return state
  }
}

const visibleIds = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_PROJECTS:
      return action.projects.map(project => project._id)
    case RECEIVE_PROJECT:
      return state.includes(action.project._id) ?
        state : [...state, action.project._id]
    case DELETE_PROJECT:
      return state.filter( (item, index) => item !== action.projectId )
    default:
      return state
  }
}

export default combineReducers({
  byId,
  visibleIds
})

export const getProject = (state, id) =>
  state.byId[id]

export const getVisibleProjects = state =>
  state.visibleIds.map(id => getProject(state, id))

const receiveProjects = projects => ({
  type: RECEIVE_PROJECTS,
  projects: projects
})

export const deleteProject = projectId => ({
  type: DELETE_PROJECT,
  projectId
})

export const receiveProject = project => ({
  type: RECEIVE_PROJECT,
  project: project
})

export const getAllProjects = () => dispatch => {
  APIRequest.get('projects').then(res => {
    dispatch(receiveProjects(res.data));
  })
}

export const getProjectById = (id) => dispatch => {
  APIRequest.get(`projects/${id}`).then(res => {
    dispatch(receiveProject(res.data));
  })
}



// WEBPACK FOOTER //
// ./src/modules/projects.js